import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Label } from './ui/label';
import { Building2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/api`;

function SuperAdminPharmacyFilter({ value, onChange, currentUser }) {
  const [pharmacies, setPharmacies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPharmacies();
  }, []);

  const fetchPharmacies = async () => {
    try {
      const headers = {
        'X-User-Id': currentUser?.id || ''
      };
      const response = await axios.get(`${API}/pharmacies`, { headers });
      setPharmacies(response.data || []);
    } catch (error) {
      console.error('Erreur lors du chargement des pharmacies:', error);
    } finally {
      setLoading(false);
    }
  };

  // Only show for super_admin
  if (currentUser?.role !== 'super_admin') {
    return null;
  }

  return (
    <div className="w-full">
      <Select 
        value={value || 'all'} 
        onValueChange={onChange}
        disabled={loading}
      >
        <SelectTrigger className="w-full border-0 bg-transparent p-0 h-auto focus:ring-0 shadow-none">
          <SelectValue>
            <div className="flex items-center gap-2">
              <span className="text-gray-700 font-semibold">Pharmacies</span>
              <span className="text-sm text-gray-500">{value === 'all' ? pharmacies.length : '1'}</span>
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="w-[400px]">
          <SelectItem value="all">
            <span className="font-semibold text-emerald-700">📊 Toutes les Pharmacies</span>
          </SelectItem>
          {pharmacies.map((pharmacy) => (
            <SelectItem key={pharmacy.id} value={pharmacy.id}>
              <span className="flex items-center gap-2">
                <Building2 className="w-4 h-4 text-emerald-500" />
                {pharmacy.name}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default SuperAdminPharmacyFilter;
